export const PREBID_RECTANGLE_CONFIG = {
  mediaTypes: {
    banner: {
      sizeConfig: [
        { minViewPort: [0, 0], sizes: [] },
        {
          minViewPort: [1060, 0],
          sizes: [[300, 250]],
        },
      ],
    },
  },
  bids: [
    { bidder: 'appnexus', params: { placementId: 13659584 } },
    {
      bidder: 'sharethrough',
      params: { pkey: 'o5RfYGz7c9LjBH9UjLYApnTi' },
    },
    {
      bidder: 'openx',
      params: {
        unit: '540188309',
        delDomain: 'wildtangent-d.openx.net',
      },
    },
    { bidder: 'ix', params: { siteId: '284096' } },
    { bidder: 'rise', params: { org: '61b9fa2c23e64f0001b76d29' } },
    {
      bidder: 'triplelift',
      params: { inventoryCode: 'WildTangent_ROS_300x250' },
    },
    {
      bidder: 'pubmatic',
      params: {
        publisherId: '156941',
        adSlot: '3762736',
      },
    },

    {
      bidder: 'richaudience',
      params: { pid: 'gP5eHK9jvN', supplyType: 'site' },
    },
    {
      bidder: 'smaato',
      params: {
        publisherId: '1100055021',
        adspaceId: '134962004',
      },
    },
    {
      bidder: 'mediafuse',
      params: {
        placementId: 31482412,
      },
    },
    {
      bidder: 'nextMillennium',
      params: {
        placement_id: '52057',
      },
    },
  ],
};
export const PREBID_LEADERBOARD_CONFIG = {
  mediaTypes: {
    banner: {
      sizeConfig: [
        { minViewPort: [0, 0], sizes: [] },
        {
          minViewPort: [1168, 0],
          sizes: [[728, 90]],
        },
      ],
    },
  },
  bids: [
    { bidder: 'appnexus', params: { placementId: 13659794 } },

    {
      bidder: 'sharethrough',
      params: { pkey: 'CQ6bQZrrNV52DcGHhK7Z4AYb' },
    },
    {
      bidder: 'openx',
      params: {
        delDomain: 'wildtangent-d.openx.net',
        unit: '540188311',
      },
    },
    { bidder: 'ix', params: { siteId: '284093' } },
    { bidder: 'rise', params: { org: '61b9fa2c23e64f0001b76d29' } },
    {
      bidder: 'triplelift',
      params: { inventoryCode: 'WildTangent_ROS_728x90' },
    },
    {
      bidder: 'pubmatic',
      params: {
        publisherId: '156941',
        adSlot: '3762737',
      },
    },

    {
      bidder: 'richaudience',
      params: { pid: 'gP5eHK9jvN', supplyType: 'site' },
    },
    {
      bidder: 'smaato',
      params: {
        publisherId: '1100055021',
        adspaceId: '134965650',
      },
    },
    {
      bidder: 'mediafuse',
      params: {
        placementId: 31482412,
      },
    },
    {
      bidder: 'nextMillennium',
      params: {
        placement_id: '52059',
      },
    },
  ],
};
export const PREBID_SKYSCRAPER_CONFIG = {
  mediaTypes: {
    banner: {
      sizeConfig: [
        {
          minViewPort: [0, 0],
          sizes: [],
        },
        {
          minViewPort: [920, 0],
          sizes: [[160, 600]],
        },
        {
          minViewPort: [1060, 0],
          sizes: [],
        },
      ],
    },
  },
  bids: [
    { bidder: 'appnexus', params: { placementId: 13659793 } },

    {
      bidder: 'sharethrough',
      params: { pkey: 'qXDKakEtPq3tNzNDVTcbpsTW' },
    },
    {
      bidder: 'openx',
      params: {
        delDomain: 'wildtangent-d.openx.net',
        unit: '540188310',
      },
    },
    { bidder: 'ix', params: { siteId: '284099' } },
    { bidder: 'rise', params: { org: '61b9fa2c23e64f0001b76d29' } },
    {
      bidder: 'triplelift',
      params: { inventoryCode: 'WildTangent_ROS_160x600' },
    },
    {
      bidder: 'pubmatic',
      params: {
        publisherId: '156941',
        adSlot: '3762734',
      },
    },

    {
      bidder: 'richaudience',
      params: { pid: 'gP5eHK9jvN', supplyType: 'site' },
    },
    {
      bidder: 'smaato',
      params: {
        publisherId: '1100055021',
        adspaceId: '134965648',
      },
    },
    {
      bidder: 'mediafuse',
      params: {
        placementId: 31482412,
      },
    },
    {
      bidder: 'nextMillennium',
      params: {
        placement_id: '52056',
      },
    },
  ],
};

export const PREBID_CONFIG = {
  userSync: {
    userIds: [
      {
        name: 'sharedId',
        storage: {
          type: 'cookie',
          name: '_pubcid',
          expires: 365,
        },
      },
    ],
  },
  enableSendAllBids: false,
  priceGranularity: {
    buckets: [
      {
        precision: 2,
        min: 0,
        max: 20,
        increment: 0.01,
      },
      {
        precision: 2,
        min: 20.05,
        max: 30,
        increment: 0.05,
      },
      {
        precision: 2,
        min: 30.1,
        max: 40,
        increment: 0.1,
      },
      {
        precision: 2,
        min: 51,
        max: 99,
        increment: 1.0,
      },
    ],
  },
  auctionOptions: {
    suppressStaleRender: true,
  },
  gptPreAuction: {
    enabled: true,
    useDefaultPreAuction: false,
  },
  /*  pubmatic: {
    bidCpmAdjustment: (bidCpm: number) =>
      bidCpmAdjustment(bidCpm, pubmaticPrecentage),
  },*/
};
